import { render, staticRenderFns } from "./menuRole.vue?vue&type=template&id=791fa53c&"
import script from "./menuRole.vue?vue&type=script&lang=js&"
export * from "./menuRole.vue?vue&type=script&lang=js&"
import style0 from "./menuRole.vue?vue&type=style&index=0&id=791fa53c&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports